module.exports = __webpack_public_path__ + "static/media/3.1b3c42f4.png";